import { Role } from '../auth/role';
import { RoleGuard } from '../auth/role-guard.service';
import { EmailComposerComponent } from './email-composer/email-composer.component';
import { EmailListIndexComponent } from './email-list-index/email-list-index.component';
import { EmailOptionsComponent } from './email-options/email-options.component';
var ɵ0 = { allowed: [Role.EMAIL_SENDER] };
var routes = [
    {
        path: 'email',
        canActivate: [RoleGuard],
        data: ɵ0,
        children: [
            { path: '', component: EmailOptionsComponent },
            { path: 'listak', component: EmailListIndexComponent },
            { path: 'kuldes', component: EmailComposerComponent },
        ]
    },
];
var EmailRoutingModule = /** @class */ (function () {
    function EmailRoutingModule() {
    }
    return EmailRoutingModule;
}());
export { EmailRoutingModule };
export { ɵ0 };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/email/email-routing.module.ts.pre-build-optimizer.js